import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { StorefrontThemeService } from 'src/app/services/storefront-theme.service';
import { Router, ActivatedRoute } from '@angular/router';
import { elementAt, forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { test } from '../../classess/DasaAppUtil';
import { dasa } from '../../classess/dasaClasses';
import { commonService } from '../services/common.service';
import Swal from 'sweetalert2';
import { SettingService } from '../services/setting.service';
import { StoreConfigurationsService } from '../services/store-configurations.service';

@Component({
    selector: 'app-whitelevel',
    templateUrl: './whitelevel.component.html',
    styleUrls: ['./whitelevel.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhitelevelComponent implements OnInit {
  businessId: number = -1;
  storeId: number = -1;
  brandId: number = -1;
  redirectURL: String = "";
  requestObject: dasa.RequestObject = new dasa.RequestObject();
  

  constructor(
    private commonService_servive: commonService,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private settingService: SettingService,
    private configurationService: StoreConfigurationsService,
    private storefrontTheme: StorefrontThemeService
  ) {}

  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe((params) => {
      this.businessId = parseInt(params['businessId']);
      this.storeId = parseInt(params['storeId']);
      this.redirectURL = params['redirectURL'];
      this.brandId = parseInt(params['brandId']);
    });

    // Only fetch theme up-front if we already know the storeId — otherwise it
    // gets fetched after getBusinessData() resolves the real storeId, avoiding
    // a wasted request to /uiSettings/getById?storeId=-1.
    if (!isNaN(this.storeId) && this.storeId > 0) {
      this.getStoreThemeSettings();
    }

    if (dasa.Utility.business == undefined ||(dasa.Utility.business.id == -1 && this.businessId != -1)) {
      this.getBusinessData();
    } else if (
      dasa.Utility.selectedBusinessId != -1 &&
      dasa.Utility.selectedStoreId != -1 &&
      this.businessId == -1 &&
      this.storeId == -1
    ) {
      this.router.navigate(['/store-items']);
    } else if (this.businessId != -1) {
      this.getBusinessData();
    } else {
    }
  }

  // get theme setting start from here
  getStoreThemeSettings() {
    this.settingService.getSettingByStore(this.storeId).subscribe({
      next: (res: any) => {
        if (res.success) {
          if (res.success) {
            dasa.Utility.uiSettings = res.data;
            test.DasaAppUtil.putInSession();
            // header color
            if (res.data.header == undefined || res.data.header == '') {
              dasa.Utility.uiSettings.header = '#034131';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--header-color',
                dasa.Utility.uiSettings.header
              );
            }

            // success button color
            if (
              res.data.buttonSaveOk == undefined ||
              res.data.buttonSaveOk == ''
            ) {
              dasa.Utility.uiSettings.buttonSaveOk = '#00046B';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--ok-button-color',
                dasa.Utility.uiSettings.buttonSaveOk
              );
            }

            // category button color
            if (
              res.data.categoryButton == undefined ||
              res.data.categoryButton == ''
            ) {
              dasa.Utility.uiSettings.categoryButton = '#deb887';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--cat-button-color',
                dasa.Utility.uiSettings.categoryButton
              );
            }

            // cancel button color
            if (
              res.data.cancelButton == undefined ||
              res.data.cancelButton == ''
            ) {
              dasa.Utility.uiSettings.cancelButton = '#dc3545';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--cancel-button-color',
                dasa.Utility.uiSettings.cancelButton
              );
            }

            // body background color
            if (
              res.data.primaryColor == undefined ||
              res.data.primaryColor == ''
            ) {
              dasa.Utility.uiSettings.primaryColor = '#d8eacc';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--body-bg-color',
                dasa.Utility.uiSettings.primaryColor
              );
            }

            // footer color
            if (res.data.footer == undefined || res.data.footer == '') {
              dasa.Utility.uiSettings.footer = '#241C15';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--footer-color',
                dasa.Utility.uiSettings.footer
              );
            }

            // checkout/menu button color
            if (
              res.data.checkOutColor == undefined ||
              res.data.checkOutColor == ''
            ) {
              dasa.Utility.uiSettings.checkOutColor = '#25F6AF';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--menu-button-color',
                dasa.Utility.uiSettings.checkOutColor
              );
            }

            // left navigation menu background color
            if (
              res.data.leftNavigationButton == undefined ||
              res.data.leftNavigationButton == ''
            ) {
              dasa.Utility.uiSettings.leftNavigationButton = '#ffffff';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--left-menu-color',
                dasa.Utility.uiSettings.leftNavigationButton
              );
            }

            // secondary background color
            if (
              res.data.secondaryColor == undefined ||
              res.data.secondaryColor == ''
            ) {
              dasa.Utility.uiSettings.secondaryColor = '#ffffff';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--secondary-bg-color',
                dasa.Utility.uiSettings.secondaryColor
              );
            }
            if (
              res.data.bodyText == undefined ||
              res.data.bodyText == ''
            ) {
              dasa.Utility.uiSettings.bodyText = '#000000';
              test.DasaAppUtil.putInSession();
            } else {
              document.documentElement.style.setProperty(
                '--body--text-color-color',
                dasa.Utility.uiSettings.bodyText
              );
            }

            // Surface/text tokens. Unlike the blocks above these always set the
            // variable — including for the default — so component styles can
            // rely on it existing rather than each restating a fallback hex and
            // drifting from the real default over time.
            document.documentElement.style.setProperty(
              '--border-color',
              (res.data.borderColor == undefined || res.data.borderColor == '')
                ? '#e5e7eb' : res.data.borderColor
            );
            document.documentElement.style.setProperty(
              '--muted-text-color',
              (res.data.mutedTextColor == undefined || res.data.mutedTextColor == '')
                ? '#374151' : res.data.mutedTextColor
            );
            // Banner falls back to the surface colour, menu bar to the header,
            // so an unconfigured store looks exactly as it did before.
            document.documentElement.style.setProperty(
              '--page-banner-color',
              (res.data.pageBannerColor == undefined || res.data.pageBannerColor == '')
                ? (dasa.Utility.uiSettings.secondaryColor || '#ffffff') : res.data.pageBannerColor
            );
            document.documentElement.style.setProperty(
              '--menu-bar-color',
              (res.data.menuBarColor == undefined || res.data.menuBarColor == '')
                ? (dasa.Utility.uiSettings.header || '#034131') : res.data.menuBarColor
            );
            const perRow = Number(res.data.cateringItemsPerRow);
            document.documentElement.style.setProperty(
              '--catering-items-per-row',
              String(perRow >= 1 && perRow <= 6 ? perRow : 3)
            );
            // Publish the whole token set from one place, so tokens added later
            // (accent, price, surface, heading) reach the storefront without
            // another block being appended here. Re-setting the tokens above
            // with the same values is harmless.
            this.storefrontTheme.apply(res.data);
          }
          else {
            dasa.Utility.uiSettings.header = '#034131';
            dasa.Utility.uiSettings.footer = '#241C15';
            dasa.Utility.uiSettings.primaryColor = '#d8eacc';
            dasa.Utility.uiSettings.buttonSaveOk = '#00046B';
            dasa.Utility.uiSettings.cancelButton = '#dc3545';
            dasa.Utility.uiSettings.categoryButton = '#deb887';
            dasa.Utility.uiSettings.checkOutColor = '#25F6AF';
            dasa.Utility.uiSettings.leftNavigationButton = '#ffffff';
            dasa.Utility.uiSettings.secondaryColor = '#ffffff';
            dasa.Utility.uiSettings.borderColor = '#e5e7eb';
            dasa.Utility.uiSettings.mutedTextColor = '#374151';
            // A store with no uisettings row lands here, so the surface tokens
            // still have to be published or component styles get nothing.
            document.documentElement.style.setProperty('--border-color', '#e5e7eb');
            document.documentElement.style.setProperty('--muted-text-color', '#374151');
            dasa.Utility.uiSettings.pageBannerColor = '#ffffff';
            dasa.Utility.uiSettings.menuBarColor = '#034131';
            document.documentElement.style.setProperty('--page-banner-color', '#ffffff');
            document.documentElement.style.setProperty('--menu-bar-color', '#034131');
            document.documentElement.style.setProperty('--catering-items-per-row', '3');
            // A store with no uisettings row still needs every token published,
            // otherwise the newer screens fall back to browser defaults.
            this.storefrontTheme.apply(dasa.Utility.uiSettings);
            test.DasaAppUtil.putInSession();
          }
        }
      },
      error: (err: any) => {},
    });
  }


  getBusinessData() {
    this.settingService
      .getPosSettings(this.storeId, this.businessId)
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            console.log('Data', res.data);
            let posSettings = res.data;
            posSettings.stores = posSettings.stores.filter(
              (x: any) => x.status !== 2
            ); //exclude disabled stores
            dasa.Utility.selectedBusinessId = this.businessId;
            dasa.Utility.selectedStoreId = this.storeId;
            dasa.Utility.selectedBrandId = this.brandId;
            dasa.Utility.brands = posSettings.brands;
            dasa.Utility.categories = posSettings.categories;
            dasa.Utility.business = posSettings.business;
            dasa.Utility.stores = posSettings.stores;
            dasa.Utility.country = posSettings.country;
            // dasa.Utility.storeConfigurations =
            if (posSettings.stores.length > 1) {
              test.DasaAppUtil.putInSession();
              this.router.navigate(['/choosestore']);
            } else {
              if (posSettings.stores != undefined && posSettings.stores.length == 1) {
                this.getStoreSettingByStore(posSettings.stores[0].id);
                this.storeId = posSettings.stores[0].id;
                this.getStoreThemeSettings();
              } else
                Swal.fire({
                  title: 'error!',
                  text: 'Store is disabled!',
                  icon: 'error'
                });
            }
          } else {
            console.error('[whitelevel] getPosSettings returned non-success:', res);
            Swal.fire({ title: 'Error', text: res?.message || 'Could not load business data', icon: 'error' });
          }
        },
        error: (err: any) => {
          console.error('[whitelevel] getPosSettings failed:', err);
          Swal.fire({ title: 'Error', text: 'Failed to load business data. Please try again.', icon: 'error' });
        },
      });
  }
  getStoreSettingByStore(storeid: number) {
    if (storeid * 1 > 0) {
      dasa.Utility.selectedStoreId = storeid;
      dasa.Utility.selectedBusinessId = dasa.Utility.business.id;

      // Fire the two independent calls in parallel instead of awaiting them serially.
      forkJoin({
        posSettings: this.settingService.getPosSettingsForStore(storeid),
        storeConfig: this.configurationService.getStoreConfigurations(storeid).pipe(
          catchError(() => of(null))
        )
      }).subscribe({
        next: ({ posSettings, storeConfig }: any) => {
          dasa.Utility.selectedStoreDetails = posSettings.data.stores;
          dasa.Utility.storeSettings = posSettings.data.storeSettings;
          dasa.Utility.storeItems = posSettings.data.storeItems;
          dasa.Utility.selectedStoreId = storeid;

          if (storeConfig?.success && storeConfig.data) {
            dasa.Utility.storeConfigurations = storeConfig.data;
          }

          test.DasaAppUtil.putInSession();

          if (posSettings.data.stores[0].status == 2) {
            Swal.fire({
              title: 'Alert!',
              text: 'Store is disabled please contact to admin!',
              icon: 'error',
            });
            return;
          }

          test.DasaAppUtil.loadFromSession();
          // Where catering lands depends on which catering surface the store
          // actually has. Stores on the legacy surface (Kleftiko) present
          // catering as the ordinary /store-items menu with cartType 2; stores
          // with Catering Management have a dedicated menu, cart and checkout
          // that /store-items knows nothing about. This used to send BOTH to
          // /store-items, so a Catering Management store dropped its customers
          // on the legacy menu and only reached the real catering surface if
          // they happened to navigate there by hand.
          const cfgSnapshot: any = dasa.Utility.storeConfigurations;
          // Both catering surfaces now render the same screens, so the routing
          // decision is simply "does this store do catering", not "which of
          // the two catering front ends does it have".
          const cateringManaged = !!cfgSnapshot?.cateringEnabled
                               || !!cfgSnapshot?.cateringManagementEnabled;
          const onDemandOn = !!cfgSnapshot?.onlineOrderingEnabled;
          if (this.redirectURL != null && this.redirectURL != "") {
            if (this.redirectURL == "catering") {
              dasa.Utility.cartType = 2;
              test.DasaAppUtil.putInSession();
              if (cateringManaged) {
                this.router.navigateByUrl('/catering/menu');
              } else {
                this.router.navigate(['/store-items']);
              }
            } else {
              dasa.Utility.cartType = 1;
              test.DasaAppUtil.putInSession();
              // Use navigateByUrl rather than navigate(['/' + redirectURL])
              // — Angular's navigate() with a single string segment doesn't
              // reliably split slashes for lazy-loaded children, so
              // multi-segment redirects like "catering/menu"
              // were 404-ing. navigateByUrl treats the input as a URL
              // path and resolves nested routes correctly.
              this.router.navigateByUrl('/' + this.redirectURL);
            }
          } else if (cateringManaged && !onDemandOn) {
            // Catering-only store on the managed surface: there is no
            // on-demand menu to show, so /store-items renders an empty or
            // wrong-brand catalogue. Go straight to the catering menu and
            // start the basket in catering mode, which also keeps the
            // customer from crossing the mode boundary later — that switch
            // is what empties a basket mid-order.
            dasa.Utility.cartType = 2;
            test.DasaAppUtil.putInSession();
            this.router.navigateByUrl('/catering/menu');
          } else {
            dasa.Utility.cartType = 1;
            test.DasaAppUtil.putInSession();
            this.router.navigate(['/store-items']);
          }
        },
        error: (err: any) => {
          console.error('[whitelevel] getPosSettingsForStore failed:', err);
        }
      });
    }
  }

}
